<template>
    <rkm-area
        title="Comunicação via WhatsApp"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-checkbox
                    v-model="model.agendamentoAtivo"
                    @change="handleAppointmentChange"
                >
                    {{ appointmentLabel }}
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox
                    :disabled="model.agendamentoAtivo"
                    v-model="model.confirmacaoAtiva"
                >
                    {{ confirmationLabel }}
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    methods: {
        handleAppointmentChange(active) {
            if (active) this.model.confirmacaoAtiva = true
        },
    },
    props: {
        appointmentLabel: { required: true, type: String },
        confirmationLabel: { required: true, type: String },
        model: { required: true, type: Object },
    },
}
</script>
